export default class QuestionDTO {
  constructor(item = {}) {
    this.id = item.id;
    this.name = item.name;
    this.content = item.content;
    this.comment = item.comment;
    this.chapters = item.chapters;
    this.thumbnail = item.thumbnail;
    this.categoryId = item.category ? String(item.category.id) : null;
    this.categoryName = item.category ? item.category.name : null;
    this.layout = item.layout;
    this.question_chapters = item.question_chapters;
    this.theory_chapters = item.theory_chapters;
    this.video_chapters = item.video_chapters;
    this.video = item.video;
    this.videos = item.videos;
    this.video_meta = item.video_meta;
    this.video_file = item.video_file;
    this.type = item.type;
    this.pointers = item.pointers || [];
    this.choices = item.choices || [
      {},
      {},
      {}
    ];
    this.numeric_answer = item.numeric_answer !== undefined ? item.numeric_answer : null;
    this.measurement_units = item.measurement_units || null;
    this.show_multiple_answers_hint = item.show_multiple_answers_hint || false;
    this.is_motor = item.is_motor || false;
    this.is_auto = item.is_auto || false;
    this.is_scooter = item.is_scooter || false;
  }

  get licenseTypes() {
    const licenseTypes = [];
    if (this.is_motor) licenseTypes.push('motor');
    if (this.is_auto) licenseTypes.push('auto');
    if (this.is_scooter) licenseTypes.push('scooter');
    return licenseTypes.join(', ');
  }
}

